import { Colors } from "@auteco/theme"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    container: {
        padding: '12px'
    },
    textField: {
        width: '300px',
        margin: '12px 12px 0 0'
    },
    btnsContainer: {
        marginTop: '12px',
        padding: '12px',
        display: 'flex'
    },
    relateBtn: {
        marginLeft: '20px'
    },
    actionBtn: {
        marginRight: '12px',
        border: `2px solid ${Colors.DARK_BLUE}`,
    }
}))

export default useStyles